<template>
    <v-container fluid class="px-8">
        <v-row>
            <v-col cols="12" md="8">
                <div class="left-column">
                    <div class="card-box">
                        <h2 class="page-title color-grey-onfly">Solicitar Cancelamento</h2>
                    </div>
                    <div class="label">Nome do solicitante <span class="red--text">*</span></div>
                    <v-text-field
                        ref="cancellerNameInput"
                        v-model="cancellerName"
                        type="text"
                        :rules="cancellerNameRules"
                        required
                        outlined
                        dense
                    />
                    <v-row>
                        <v-col
                            v-for="(adjustmentForm, index) in adjustmentForms" :key="index" cols="12" md="6">
                            <div class="card-box">
                                <div v-if="adjustmentForms.length > 1" class="d-flex justify-end">
                                    <v-btn icon small @click="removeAdjustmentForm(index)">
                                        <v-icon color="red">mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                                <cancel-reserve-form ref="cancelForms" />
                            </div>
                        </v-col>
                    </v-row>
                    <div class="additional-actions">
                        <p class="color-grey-onfly">Há mais divergências?</p>
                        <v-btn class="additional-request" @click="addAdjustmentForm">+ Solicitar também mais uma alteração</v-btn>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" md="4">
                <div class="right-column card-box">
                    <div class="card-box">
                        <h2 class="page-title color-grey-onfly">Informações da Reserva</h2>
                    </div>

                    <div class="card-box">
                        <div class="card-box">
                            <h3 class="page-title color-grey-onfly">{{ booking ? booking.hotel.name : '...' }}</h3>
                        </div>
                        <div v-if="booking" class="booking-info">
                            <div class="booking-dates color-grey-onfly">
                                <v-icon >mdi-calendar</v-icon>
                                <span>{{ booking.check_in }}</span>
                                <v-icon small>mdi-arrow-right</v-icon>
                                <span>{{ booking.check_out }}</span>
                            </div>
                            <div class="booking-guests-total color-grey-onfly">
                                <v-icon >mdi-account</v-icon>
                                <span>{{ booking.total_booking_guests }} hóspede(s)</span>
                                <span>.</span>
                                <span>Total: R$ {{ booking.total_value }}</span>
                            </div>
                        </div>
                        <v-progress-circular v-else indeterminate color="primary" />
                    </div>

                    <div class="description color-grey-onfly" >
                        <p>• Use este formulário justificar os motivos do cancelamento da reserva</p>
                        <p>• Isso garante que outras reservas não serão canceladas pelo mesmo motivo no futuro</p>
                    </div>

                    <div class="decision-buttons">
                        <v-btn class="decision-button request-cancellation-button" @click="submitAdjustments">Solicitar o cancelamento da reserva</v-btn>
                        <v-btn class="decision-button cancel-button" @click="goBack">Voltar</v-btn>
                    </div>
                    <response-dialog
                        :model.sync="responseDialog.model"
                        :type="responseDialog.type"
                        :message="responseDialog.message"
                        @close="goBack"
                    />
                    <update-fare-on-cancellation-modal
                        :show="fareUpdateModal.show"
                        :rooms="fareUpdateModal.rooms"
                        @confirm="onFareUpdateConfirmed"
                        @dismiss="onFareUpdateDismissed"
                    />
                    <prompt-update-other-fares-modal
                        :show="updateOtherFaresModal.show"
                        :loading="updateOtherFaresModal.loading"
                        @confirm="onUpdateOtherFaresConfirmed"
                        @dismiss="onUpdateOtherFaresDismissed"
                    />
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CancelReserveForm from "../../components/HotelOwnerActions/CancelReserveForm.vue";
import ResponseDialog from "../../components/Dialog/ResponseDialog.vue";
import UpdateFareOnCancellationModal from "../../components/HotelOwnerActions/UpdateFareOnCancellationModal.vue";
import PromptUpdateOtherFaresModal from "../../components/HotelOwnerActions/PromptUpdateOtherFaresModal.vue";

export default {
    name: "CancelReserveWithReasons",
    components: { CancelReserveForm, ResponseDialog, UpdateFareOnCancellationModal, PromptUpdateOtherFaresModal },

    data: () => ({
        booking: null,
        adjustmentForms: [{}],
        cancellerName: null,
        cancellerNameRules: [
            v => !!v || 'Campo Obrigatório',
        ],
        responseDialog: {
            model: false,
            type: '',
            message: '',
        },
        fareUpdateModal: {
            show: false,
            rooms: [],
        },
        updateOtherFaresModal: {
            show: false,
            loading: false,
        },
        fareWasUpdated: false,
        pendingPayload: null,
    }),

    methods: {
        addAdjustmentForm() {
            this.adjustmentForms.push({})
        },

        removeAdjustmentForm(index) {
            this.adjustmentForms.splice(index, 1)
        },

        submitAdjustments() {
            const isCancellerNameValid = this.$refs.cancellerNameInput.validate(true)
            const adjustmentFormsData = this.$refs.cancelForms.map(form => form.getFormData())
            const hasInvalidForm = adjustmentFormsData.some(data => data === null)
            if (!isCancellerNameValid || hasInvalidForm) return

            const payload = {
                cancellerName: this.cancellerName,
                emittedByOperator: false,
                canceledReason: this.$refs.cancelForms[0].formatToString(),
                adjustmentsRequest: adjustmentFormsData,
            }

            const hasCommercial = adjustmentFormsData.some(d => d.adjustmentType === 'commercial')
            const eligibleRooms = (this.booking && this.booking.rooms || [])
                .filter(r => r.fare && !r.fare.agreement && r.fare.active)
            const expandedRooms = this.expandCombinedRooms(eligibleRooms)

            if (hasCommercial && expandedRooms.length > 0) {
                this.pendingPayload = payload
                this.fareUpdateModal.rooms = expandedRooms
                this.fareUpdateModal.show = true
                return
            }

            this.sendCancellationRequest(payload)
        },

        expandCombinedRooms: function(rooms) {
            var result = []
            rooms.forEach(function(room) {
                var fare = room.fare
                var elements = fare && fare.source_elements ? fare.source_elements : []

                if (!fare.is_combined || elements.length === 0) {
                    result.push(room)
                    return
                }

                elements.forEach(function(el, index) {
                    result.push(Object.assign({}, room, {
                        isCombined: true,
                        combinedGroupId: room.id + '_' + fare.id,
                        combinedAverageAmount: fare.amount,
                        combinedTotalNights: elements.reduce(function(total, element) {
                            return total + Number(element.quantity || 0)
                        }, 0),
                        combinedTitle: 'Tarifa ' + (index + 1),
                        combinedNightsLabel: el.quantity + (el.quantity > 1 ? ' noites' : ' noite'),
                        combinedLabel: 'Tarifa ' + (index + 1) + ' · ' + el.quantity + (el.quantity > 1 ? ' noites' : ' noite'),
                        applicableDaysLabel: el.applicable_days_label,
                        fare: {
                            id: el.source_fare_id,
                            amount: el.amount,
                            agreement: fare.agreement,
                            active: fare.active,
                        },
                    }))
                })
            })
            return result
        },

        onFareUpdateConfirmed(fareUpdates) {
            this.fareUpdateModal.show = false
            const payload = Object.assign({}, this.pendingPayload, { updatedFares: fareUpdates })
            this.pendingPayload = null
            this.fareWasUpdated = true
            this.sendCancellationRequest(payload)
        },

        onFareUpdateDismissed() {
            this.fareUpdateModal.show = false
            const updatedFares = this.fareUpdateModal.rooms.map(function(room) {
                return { fareId: room.fare.id, newAmountInCents: null, isConfirming: false }
            })
            const payload = Object.assign({}, this.pendingPayload, { updatedFares: updatedFares })
            this.pendingPayload = null
            this.sendCancellationRequest(payload)
        },

        sendCancellationRequest(payload) {
            axios.put(`/api/booking/confirm/${this.$route.params.hashId}`, payload)
                .then(res => {
                    res.status === 200 ? this.onSubmitSuccess() : this.onSubmitError()
                })
                .catch((error) => {
                    this.fareWasUpdated = false
                    if (error.response?.status === 422) {
                        this.onAlreadySubmitError()
                    } else {
                        this.onSubmitError()
                    }
                })
        },

        onSubmitSuccess() {
            if (this.fareWasUpdated) {
                this.fareWasUpdated = false
                this.updateOtherFaresModal.show = true
                return
            }
            this.responseDialog.type = 'success'
            this.responseDialog.message = 'Solicitação de cancelamento registrada com sucesso!'
            this.responseDialog.model = true
            this.clearForms()
        },

        onUpdateOtherFaresConfirmed() {
            this.updateOtherFaresModal.loading = true
            axios.get(`/api/booking/cancel/${this.$route.params.hashId}/update-fares-link`)
                .then(res => {
                    window.location.href = res.data.updateFaresUrl
                })
                .catch(() => {
                    this.updateOtherFaresModal.loading = false
                    this.updateOtherFaresModal.show = false
                    this.responseDialog.type = 'error'
                    this.responseDialog.message = 'Não foi possível gerar o link de atualização. Tente novamente.'
                    this.responseDialog.model = true
                })
        },

        onUpdateOtherFaresDismissed() {
            this.updateOtherFaresModal.show = false
            this.responseDialog.type = 'success'
            this.responseDialog.message = 'Solicitação de cancelamento registrada com sucesso!'
            this.responseDialog.model = true
            this.clearForms()
            axios.post(`/api/booking/cancel/${this.$route.params.hashId}/dismiss-fares-offer`)
        },

        onSubmitError() {
            this.responseDialog.type = 'error'
            this.responseDialog.message = 'Não foi possível registrar a solicitação. Tente novamente.'
            this.responseDialog.model = true
        },

        onAlreadySubmitError() {
            this.responseDialog.type = 'error'
            this.responseDialog.message = 'A reserva já foi cancelada ou concluída.'
            this.responseDialog.model = true
            this.clearForms()
        },

        onDetailsError() {
            this.responseDialog.type = 'error'
            this.responseDialog.message = 'Não foi possível carregar os detalhes da reserva. Tente novamente.'
            this.responseDialog.model = true
        },

        goBack() {
            window.location.href = `/api/booking/confirm/${this.$route.params.hashId}`
        },

        redirectToNotFound() {
            this.$router.push({ name: 'reserveNotFound' })
        },

        clearForms() {
            this.$refs.cancelForms.map(form => form.clearForm())
            this.adjustmentForms = [{}]
            this.cancellerName = null
        },

        fetchBookingDetails() {

            axios.get(`/api/booking/cancel/${this.$route.params.hashId}/details`)
                .then(res => {
                    this.booking = res.data
                    this.$root.$emit('set-layout-subtitle', `Reserva: #${this.booking.id}`)
                })
                .catch((error) => {
                    if (error.response?.status === 404) {
                        this.redirectToNotFound()
                    } else {
                        this.onDetailsError()
                    }
                })
        },
    },

    mounted() {
        this.fetchBookingDetails()
    },
}
</script>

<style lang="scss" scoped>
.color-grey-onfly {
    color: #54667a !important;
}
.page-title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 24px;
}
.card-box {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    padding: 16px;
    border: 1px solid lightgrey;
    margin-bottom: 16px;
    text-align: center;
}
.description {
    padding: 16px 32px;
    text-align: left;
}
.decision-buttons {
    display: flex;
    flex-direction: column;
}
::v-deep .decision-button {
    width: 100%;
    margin-bottom: 16px;
    color: #FFFFFF !important;
    font-weight: bold;
    text-transform: none;
    padding: 24px 0 !important;
}
::v-deep .additional-request {
    text-transform: none;
    background-color: #8E8E8E !important;
    color: #FFFFFF !important;
    font-weight: bold;
}
::v-deep .request-cancellation-button {
    background-color: #6AA84F !important;
}
::v-deep .cancel-button {
    background-color: #8E8E8E !important;
}
.label {
    text-align: left;
    padding-bottom: 8px;
}
.booking-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px 0;
}
.booking-dates, .booking-guests-total {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 20px;

    @media (max-width: 1800px) {
        font-size: 14px;
        gap: 4px;
    }

    @media (max-width: 959px) {
        font-size: 20px;
    }
}
</style>
